import { NodeSortAction } from "@iventis/domain-model/model/nodeSortAction";
import { FieldSort } from "@iventis/types";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";

const localStorageKey = "user-preferences";

export const userLocalStorageItems = {
    folderBrowserView: "folder-browser-view" as const,
    mapUnitOfMeasurement: "map-unit-of-measurement" as const,
    folderBrowserSort: "folder-browser-sort" as const,
    analysisHelp: "analysis-help" as const,
    objectDetailsPanel: "object-details-panel" as const,
    exportPreviewPositionMapOverlay: "export-preview-position-map-overlay" as const,
};

type UserStorageItems = {
    [userLocalStorageItems.folderBrowserView]: string;
    [userLocalStorageItems.mapUnitOfMeasurement]: UnitOfMeasurement;
    [userLocalStorageItems.folderBrowserSort]: FieldSort<NodeSortAction>;
    [userLocalStorageItems.analysisHelp]: boolean;
    [userLocalStorageItems.objectDetailsPanel]: boolean;
    [userLocalStorageItems.exportPreviewPositionMapOverlay]: boolean;
};

function generateUserLocalStorageKey(userId: string) {
    return `${localStorageKey}:${userId}`;
}

/** Gets user preferences, Partial as certain keys could not be set yet */
function getUserPreferences(userId: string): Partial<UserStorageItems> {
    const userPreferenceJson = localStorage.getItem(generateUserLocalStorageKey(userId));
    if (userPreferenceJson == null) {
        return {};
    }
    return JSON.parse(userPreferenceJson);
}

/** Type safe userLocalStorage management. get() calls userLocalStorage.getItem() and set() calls userLocalStorage.setItem() */
export const userLocalStorageManager = {
    get: <T extends keyof UserStorageItems>(key: T, userId: string) => {
        const userPreferences = getUserPreferences(userId);
        return userPreferences?.[key];
    },
    set: <T extends keyof UserStorageItems>(key: T, userId: string, item: UserStorageItems[typeof key]): void => {
        // If user preferences does not exist use blank object
        const userPreferences = getUserPreferences(userId) ?? {};
        userPreferences[key] = item;
        localStorage.setItem(generateUserLocalStorageKey(userId), JSON.stringify(userPreferences));
    },
};
